import React from 'react';
import PropTypes from 'prop-types';
import {t} from 'lib/I18n';
import RewardDetails from '../challenge/RewardDetails';

export default function SuperbadgeReward({
  reward,
  next = undefined,
  sharing = undefined,
  modalRef,
  wasRetake,
}) {
  const { superbadge, challengePoints } = reward;

  const newPointsBreakdown = !wasRetake ? (
    <div className="slds-m-bottom--large">
      <p className="th-unit-reward__heading th-color--success th-text th-text--tight th-text--bold">
        {t('superbadges.challenge_points', {points: challengePoints})}
      </p>

      <p className="th-unit-reward__heading th-color--success th-text th-text--tight th-text--bold">
        {t('superbadges.bonus_points', {points: superbadge.completion_points})}
      </p>
    </div>
  ) : null;

  const survey = {
    title: t('superbadges.survey.heading'),
    link_text: t('superbadges.survey.link_text'),
    url: `https://www.surveymonkey.com/r/SuperbadgeCredentialFeedback?sbc=${superbadge.api_name}`
  };

  return (
    <RewardDetails
      title={t('reward.module.heading')}
      badgeName={superbadge.title}
      iconUrl={superbadge.icon_url}
      assistiveText={{iconLabel: t('superbadges.complete')}}
      pointsBreakdown={newPointsBreakdown}
      next={next}
      sharing={sharing}
      survey={survey}
      modalRef={modalRef}
    />
  );
}

SuperbadgeReward.propTypes = {
  reward: PropTypes.shape({
    superbadge: PropTypes.object.isRequired,
    challengePoints: PropTypes.number.isRequired
  }),
  next: PropTypes.object,
  sharing: PropTypes.object,
  wasRetake: PropTypes.bool,
};
